var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"title please_wait_txt"},[_vm._v("\n  "+_vm._s(_vm.getTranslations.home_loader_please_wait)+"\n  "),_c('span',{attrs:{"id":"wait-custom"}},[_vm._v(_vm._s(_vm.animatedDotText))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-151316c6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/loader/TextLoader.vue
// module id = null
// module chunks = 